import { anzeigeName, type DashboardCoaching } from '@/core/types'
import { AUFGABE } from '@/core/data/aufgabe'
import { createParticipantLink } from '@/core/api/portal'

export function openVertragCoachings(rows: readonly DashboardCoaching[]): DashboardCoaching[] {
  return rows.filter((c) => c.stage === 'vertrag' && c.aufgabe === AUFGABE.vertragUnterschreiben.dbName)
}

export function vertragReminderDisabledHint(rows: readonly DashboardCoaching[]): string | null {
  return openVertragCoachings(rows).length === 0 ? 'kein Vertrag offen' : null
}

export type VertragReminderResult = {
  sent: DashboardCoaching[]
  failed: DashboardCoaching[]
}

export async function sendVertragReminders(
  targets: readonly DashboardCoaching[],
): Promise<VertragReminderResult> {
  const settled = await Promise.allSettled(targets.map((c) => createParticipantLink(c.id, 'vertrag', true)))
  const result: VertragReminderResult = { sent: [], failed: [] }
  settled.forEach((s, i) => {
    if (s.status === 'fulfilled') result.sent.push(targets[i])
    else {
      console.error('Vertrag-Erinnerung fehlgeschlagen:', targets[i].id, s.reason)
      result.failed.push(targets[i])
    }
  })
  return result
}

export function vertragReminderToast(result: VertragReminderResult): { tone: 'success' | 'error'; message: string } {
  if (result.failed.length === 0) {
    return { tone: 'success', message: `Erinnerung an ${result.sent.length} Teilnehmende gesendet` }
  }
  const names = result.failed.map(anzeigeName).join('; ')
  const lead = result.sent.length > 0 ? `Erinnerung an ${result.sent.length} Teilnehmende gesendet. ` : ''
  return { tone: 'error', message: `${lead}Nicht gesendet an: ${names}` }
}
